export const headers = [
    { field: "id", headerName: "ID", width: 70, hidden: true },
    { field: "codigo_rubro", headerName: "Codigo", width: 90 },
    { field: "descripcion_rubro", headerName: "Descripcion", width: 230 },
    { field: "descripcion_ramo", headerName: "Ramo", width: 130 },
  ];
  